import { render, staticRenderFns } from "./ExpressCreationDestinations.vue?vue&type=template&id=88367cda&"
import script from "./ExpressCreationDestinations.vue?vue&type=script&lang=ts&"
export * from "./ExpressCreationDestinations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports